import { BaseType } from '../types/Enums';

// Centralized list of relevant BaseTypes for maintenance and component management
// This list defines the order and which BaseTypes are included across the application
export const RELEVANT_BASE_TYPES = [
    BaseType.Roof,
    BaseType.Facade,
    BaseType.RoofDrainage,
    BaseType.GroundDrainage,
    BaseType.Chimney,
    BaseType.Foundation,
    BaseType.Utility,
    BaseType.Door,
    BaseType.Outdoor,
    BaseType.Window,
    BaseType.SheetMetal
];

// BaseTypes that are relevant for breadcrumb navigation
export const NAVIGABLE_BASE_TYPES = [
    BaseType.Roof,
    BaseType.Foundation,
    BaseType.RoofDrainage,
    BaseType.GroundDrainage,
    BaseType.Facade,
    BaseType.Outdoor,
    BaseType.Chimney
];

// Grouped BaseTypes for MaintenanceDraft sections
// Each group will be displayed as a single section with a combined title
export interface BaseTypeGroup {
    key: string;
    label: string;
    baseTypes: BaseType[];
}

export const BASE_TYPE_GROUPS: BaseTypeGroup[] = [
    {
        key: 'roof_drainage',
        label: 'Tak & avvattning',
        baseTypes: [BaseType.Roof, BaseType.RoofDrainage, BaseType.SheetMetal]
    },
    {
        key: 'facade-windows',
        label: 'Fasad & fönster',
        baseTypes: [BaseType.Facade, BaseType.Window]
    },
    {
        key: 'chimney',
        label: 'Skorsten',
        baseTypes: [BaseType.Chimney]
    },
    {
        key: 'foundation',
        label: 'Grund & dränering',
        baseTypes: [BaseType.Foundation, BaseType.GroundDrainage]
    },
    {
        key: 'utility',
        label: 'Husinstallationer',
        baseTypes: [BaseType.Utility]
    },
    {
        key: 'door',
        label: 'Dörr',
        baseTypes: [BaseType.Door]
    },
    {
        key: 'outdoor',
        label: 'Utvändigt',
        baseTypes: [BaseType.Outdoor]
    }
];

// Helper functions
export const isRelevantBaseType = (baseType: BaseType): boolean => {
    return RELEVANT_BASE_TYPES.includes(baseType);
};

export const getBaseTypeOrder = (baseType: BaseType): number => {
    const index = RELEVANT_BASE_TYPES.indexOf(baseType);
    return index === -1 ? 999 : index; // Put unknown types at the end
};
